<template>
  <ContentWrap>
    <el-form :model="query" inline>
      <el-form-item label="用户昵称"
        ><BusinessLookupSelect v-model="query.userId" type="users" placeholder="请选择用户"
      /></el-form-item>
      <el-form-item label="记忆类型"
        ><el-select v-model="query.memoryType" clearable class="!w-150px"
          ><el-option
            v-for="item in memoryTypes"
            :key="item"
            :label="item"
            :value="item" /></el-select
      ></el-form-item>
      <el-form-item label="状态"
        ><el-select v-model="query.status" clearable class="!w-120px"
          ><el-option
            v-for="(label, value) in statusLabels"
            :key="value"
            :label="label"
            :value="Number(value)" /></el-select
      ></el-form-item>
      <el-form-item label="创建时间"
        ><el-date-picker
          v-model="timeRange"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
      /></el-form-item>
    <el-form-item>
      <el-button type="primary" @click="search">查询</el-button>
    </el-form-item>
    </el-form>
  </ContentWrap>
  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="用户昵称" min-width="120"><template #default="scope"><BusinessLookupName type="users" :id="scope.row.userId" /></template></el-table-column>
      <el-table-column prop="memoryType" label="记忆类型" width="130" />
      <el-table-column prop="memoryKey" label="业务键" min-width="150" />
      <el-table-column prop="consentVersion" label="同意版本" width="120" />
      <el-table-column label="状态" width="100"
        ><template #default="scope">{{ statusLabels[scope.row.status] }}</template></el-table-column
      >
      <el-table-column prop="expireTime" label="过期时间" width="180" />
      <el-table-column label="操作" width="140">
        <template #default="scope">
          <el-button link type="primary" @click="openDetail(scope.row.id)">详情</el-button>
          <el-button
            v-if="scope.row.status !== 3"
            v-hasPermi="['bosscircle:ai-memory:manage']"
            link
            type="danger"
            @click="clear(scope.row)"
            >清除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>
  <Dialog v-model="detailVisible" title="AI 记忆详情" width="760px">
    <el-descriptions v-if="detail" :column="2" border>
      <el-descriptions-item label="用户ID">{{ detail.userId }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{ statusLabels[detail.status] }}</el-descriptions-item>
      <el-descriptions-item label="记忆类型">{{ detail.memoryType }}</el-descriptions-item>
      <el-descriptions-item label="业务键">{{ detail.memoryKey }}</el-descriptions-item>
      <el-descriptions-item label="同意版本">{{ detail.consentVersion }}</el-descriptions-item>
      <el-descriptions-item label="清除时间">{{ detail.clearTime || '-' }}</el-descriptions-item>
      <el-descriptions-item label="用户确认内容" :span="2">
        <pre class="m-0 whitespace-pre-wrap">{{ formatJson(detail.contentJson) }}</pre>
      </el-descriptions-item>
    </el-descriptions>
  </Dialog>
</template>

<script setup lang="ts">
import * as AiMemoryApi from '@/api/business/aiMemory'

defineOptions({ name: 'BossCircleAiMemory' })
const message = useMessage()
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const timeRange = ref<string[]>([])
const detailVisible = ref(false)
const detail = ref<any>()
const memoryTypes = ['GOAL', 'INDUSTRY', 'PREFERENCE', 'RELATION']
const statusLabels: Record<number, string> = { 0: '停用', 1: '有效', 2: '已过期', 3: '已清除' }
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  userId: undefined,
  memoryType: undefined,
  status: undefined
})
const load = async () => {
  loading.value = true
  try {
    const data = await AiMemoryApi.getAiMemoryPage({
      ...query,
      beginTime: timeRange.value?.[0],
      endTime: timeRange.value?.[1]
    })
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const search = () => {
  query.pageNo = 1
  load()
}
const openDetail = async (id: number) => {
  detail.value = await AiMemoryApi.getAiMemory(id)
  detailVisible.value = true
}
const formatJson = (value: string) => {
  try {
    return JSON.stringify(JSON.parse(value), null, 2)
  } catch {
    return value || '-'
  }
}
const clear = async (row: any) => {
  await message.confirm('确认清除该 AI 记忆吗？清除后内容不可恢复。')
  await AiMemoryApi.clearAiMemory({ id: row.id, version: row.version })
  message.success('清除成功')
  await load()
}
onMounted(load)
</script>
